import React from "react";
import { useNavigate } from "react-router-dom";
import { HorizontalBar, Pagination, PaginationButton } from "./style";
import { useState, useEffect } from 'react';
import Select from "react-select";
import "./index.css";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import ReactLoading from "react-loading";
import APIConfig from "../../../api/APIConfig";

import {
    Box,
    Center,
    Text,
    Button,
    VStack,
} from '@chakra-ui/react';

function AdminProposal() {;
    const [listProposal, setListProposal] = useState([]);
    const [spinner, setSpinner] = useState(false);  

    const navigate = useNavigate();
    const getListProposal = async() => {
        setSpinner(true);
        const response = await APIConfig.get("/v1/list-proposal/");
        const data = await response.data
        console.log("dataaa ", data)
        setListProposal(data);

        setSpinner(false);
    };

    const [selectedValue, setSelectedValue] = useState(0);
    const handleSearchKategori = (e) => {
        setSelectedValue(e.value);
    };


    const matcher = (data) => {
        console.log(selectedValue);
        if (selectedValue === 0) return true;
        else if (selectedValue === 1) {
            if (data.statusProposal === "Ditolak") return true;
        } else if (selectedValue === 2) {
            if (data.statusProposal ==="Butuh Revisi") return true;
        } else if (selectedValue === 3) {
            if (data.statusProposal ==="Dipublikasikan") return true;
        } else if (selectedValue === 4) {
            if (data.statusProposal ==="Terkumpul") return true;
        } else if (selectedValue === 5) {
            if (data.statusProposal === "Batal") return true;
        } else if (selectedValue === 6) {
            if (data.statusProposal === "Selesai") return true;
        }
        return false;
    };

    useEffect(() => {
        getListProposal();
        
    }, []);

    const optionKategori = [
        { value: 0, label: "--- Pilih Status ---" },
        { value: 1, label: "Ditolak" },
        { value: 2, label: "Butuh Revisi" },
        { value: 3, label: "Dipublikasikan" },
        { value: 4, label: "Terkumpul" },
        { value: 5, label: "Batal" },
        { value: 6, label: "Selesai" },
    ]

    let data = listProposal;
    const [currentPage, setCurrentPage] = useState(1);
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(data.length / 10); i++) {
        pageNumbers.push(i);
    }

    const indexOfLastData = currentPage * 10;
    const indexOfFirstData = indexOfLastData - 10;
    data = data.slice(indexOfFirstData, indexOfLastData);
    data = data.filter((i) => matcher(i));

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }

    return(
        <div className="container">
        <div>
        <Center py={6}>
        <VStack align='stretch' fontFamily={'Inter'} pb={20}>
            <Text
                pt={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}>
                Verifikasi Proposal
            </Text>
            <Box fontSize='xs' width='30%' pt={3} paddingBottom={3}>
            <Select
                borderRadius="50%"
                fontSize='13px'
                pt={3}
                paddingBottom={3}
                border='1px solid #F5F5F5'
                width='30%'
                height='40px' 
                id='kategori' 
                options={optionKategori}
                onChange={handleSearchKategori}
                value={optionKategori.find((obj) => obj.value === selectedValue)}
                placeholder=" --- Status --- " />
            </Box>
            <Box
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                rounded={'2xl'}
                p={2}
                overflow={'hidden'}>
                <VStack align='center'>
                {data.length > 0 ? 
                    <Table style={{width: '92.5%', margin: '20px 0'}}>
                        <Thead className="head">
                            <Tr>
                            <Th className='layout'><p className='layoutp'>Nama Perusahaan</p></Th>
                            <Th className='layout'><p className='layoutp'>Proposal Kegiatan</p></Th>
                            <Th className='layout'><p className='layoutp'>Status</p></Th>
                            <Th className='layout'><p className='layoutp'>Keterangan Revisi</p></Th>
                            <Th className='layout'><p className='layoutp'>Detail</p></Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {data.map((data1) => (
                            <Tr>
                                <Td className='layout'><p className='layoutp'>{data1.mitra.namaResmi}</p></Td>
                                <Td className='layout'><p className='layoutp'>{data1.namaProposal}</p></Td>
                                <Td className='layout'><p className='layoutp'>{data1.statusProposal}</p></Td>
                                <Td className='layout'><p className='layoutp'>{data1.keteranganRevisi}</p></Td>
                                <Td>
                                    <Button 
                                        onClick={() => navigate(`/admin/detail/proposal/${data1.idProposal}`)}
                                        size='xs' rounded={'xl'} colorScheme='purple' variant='solid' fontSize={'xs'} margin={'0 10px'}>
                                        Lihat Proposal
                                    </Button>
                                </Td>
                            </Tr>
                            ))}
                        </Tbody>
                    </Table>
                    : 
                    <Text fontSize={"large"} fontWeight={'600'}>Tidak ada proposal</Text>
                    }
                    {data.length > 0 ? (<HorizontalBar last={true} />) : null}
                                {pageNumbers.length > 1 && (
                                    <Pagination
                                    style={{margin: 'auto'}}>
                                        <PaginationButton onClick={() => 
                                            setCurrentPage(1)}>
                                            &lt;&lt;
                                        </PaginationButton>
                                        <PaginationButton onClick={() => 
                                            currentPage === 1 ? setCurrentPage(1) : setCurrentPage(currentPage-1)}>
                                            &lt;
                                        </PaginationButton>
                                        {pageNumbers.map((page) => (
                                            <PaginationButton
                                                unshow={
                                                    currentPage > 2 && pageNumbers.length - currentPage > 1
                                                    ? Math.abs(currentPage - page) > 2
                                                    : pageNumbers.length - currentPage < 2
                                                    ? pageNumbers.length - page > 4
                                                    : page > 5
                                                }
                                                active={currentPage === page}
                                                onClick={() => setCurrentPage(page)}
                                                >
                                                    {page}
                                            </PaginationButton>
                                        ))}
                                        <PaginationButton
                                            onClick={() =>
                                            currentPage === pageNumbers.length
                                                ? setCurrentPage(pageNumbers.length)
                                                : setCurrentPage(currentPage + 1)
                                            }
                                        >
                                            &gt;
                                        </PaginationButton>
                                        <PaginationButton onClick={() => setCurrentPage(pageNumbers.length)}>
                                            &gt;&gt;
                                        </PaginationButton>
                                    </Pagination>
                                )}
                </VStack>
            </Box>
            </VStack>
            </Center>
        </div>
        </div>
    );
}

export default AdminProposal;